import React, { FC, useEffect, useState } from 'react';
import { usePopper } from 'react-popper';
import { PositioningStrategy } from '@popperjs/core';
import { Portal } from '@src/core/Portal';
import { IDefaultComponentProps } from '@src/models/props';
import { TPlacement } from './models';
import { classnames } from '@src/utils/classnames';

import styled from './Popover.module.scss';

export interface IProps extends IDefaultComponentProps {
  /** Расположение поповера */
  placement?: TPlacement;

  /** Статус */
  open: boolean;

  /** Элемент родителя */
  anchorEl: HTMLElement;

  offset?: [number | undefined, number | undefined];

  strategy?: PositioningStrategy;

  /**
   * Поповер не будет двигаться при скролле контейнера где нах-ся якорь,
   * он будет абослютно зафиксирован отностильно страницы,
   * актуально только с stategy = 'absolute'
   **/
  isFixed?: boolean;

  /** Контейнер куда будет вставляться поповер, по дефолту это document */
  container?: HTMLElement | null;
}

/** Компонент для отображения поповера */
export const Popover: FC<IProps> = ({
  children,
  container,
  placement,
  open,
  anchorEl,
  className,
  offset,
  strategy,
  isFixed,
}) => {
  const [popper, setPopper] = useState<HTMLDivElement | null>(null);
  const [fixedStyles, setFixedStyles] = useState<React.CSSProperties>({});
  const { styles, attributes } = usePopper(anchorEl, popper, {
    placement,
    strategy,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset,
        },
      },
    ],
  });

  useEffect(() => {
    if (isFixed && styles.popper.transform && Object.keys(fixedStyles).length === 0) {
      setFixedStyles(styles.popper);
    }
  }, [fixedStyles, isFixed, styles]);

  const classes = classnames(styled.root, className);

  return (
    <>
      {open && (
        <Portal container={container}>
          <div
            tabIndex={0}
            ref={setPopper}
            style={isFixed ? fixedStyles : styles.popper}
            className={classes}
            {...attributes.popper}
          >
            {children}
          </div>
        </Portal>
      )}
    </>
  );
};
